<div class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
  <div
    class="bg-white rounded-lg shadow-lg px-6 pt-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto"
  >
    <h2 class="text-lg font-bold mb-4">Editar experiencia</h2>
    <form
      [formGroup]="experienceForm"
      (ngSubmit)="onUpdateClick()"
      class="space-y-6"
    >
      <div
        class="flex flex-col space-y-4 md:grid md:grid-cols-2 md:gap-4 md:space-y-0"
      >
        <app-input-text
          label="Nombre de la empresa"
          placeholder="Ej: Microsoft"
          [control]="experienceForm.get('companyName')"
        />
        <app-input-select
          label="Título de empleo"
          placeholder="Seleccione el título"
          [control]="experienceForm.get('idJobTitle')"
          [options]="jobTitles"
        >
        </app-input-select>
      </div>
      <div
        class="flex flex-col space-y-4 md:grid md:grid-cols-2 md:gap-4 md:space-y-0"
      >
        <app-input-select
          label="Área"
          placeholder="Seleccione el area"
          [control]="experienceForm.get('idArea')"
          [options]="areas"
        >
        </app-input-select>
        <app-input-select
          label="Línea de negocio"
          placeholder="Seleccione linea de negocio"
          [control]="experienceForm.get('idBusinessLine')"
          [options]="bussinessLines"
        >
        </app-input-select>
      </div>
      <app-input-textarea
        label="Funciones"
        placeholder="Describe tus funciones"
        [control]="experienceForm.get('functionsDescription')"
      />
      <div class="mb-4"></div>
      <div
        class="flex flex-col space-y-4 md:grid md:grid-cols-2 md:gap-4 md:space-y-0"
      >
        <app-input-date
          label="Desde"
          [control]="experienceForm.get('fromProperty')"
        ></app-input-date>
        <app-input-date
          label="Hasta"
          [control]="experienceForm.get('until')"
        ></app-input-date>
      </div>
      <div formArrayName="references" class="space-y-3">
        <h3 class="font-semibold">Referencias</h3>
        <div
          *ngFor="let ref of references.controls; let i = index"
          [formGroupName]="i"
          class="space-y-2"
        >
          <div
            class="flex flex-col space-y-4 md:grid md:grid-cols-2 md:gap-4 md:space-y-0"
          >
            <app-input-text
              label="Nombre de contacto"
              placeholder="Ej: Juan Pérez"
              [control]="ref.get('fullNameContact')"
            />
            <app-input-text
              label="Teléfono de contacto"
              placeholder="Ej: 987654321"
              [control]="ref.get('telfContact')"
            />
          </div>
        </div>
      </div>
      <div class="flex justify-end gap-2 sticky bottom-0 bg-white pt-4 pb-6">
        <button
          type="button"
          (click)="onCloseClick()"
          class="px-4 py-2 bg-gray-200 rounded shadow"
        >
          Cancelar
        </button>
        <app-loading-button
          [text]="'Guardar'"
          [loading]="loading"
          type="submit"
        >
        </app-loading-button>
      </div>
    </form>
  </div>
</div>
